export const commentary: { [key: string]: string } = {
  'commentary.pendingAction.PASS': 'is looking for passing options',
  'commentary.pendingAction.STALL': 'is dawdling',
  'commentary.pendingAction.RUN': 'is running',
  'commentary.pendingAction.SHOOT': 'lines up a shot',
  'commentary.pendingAction.LONG_PASS': 'is looking long for passing options',
  'commentary.pendingAction.SHORT_PASS': 'is looking short for passing options',
  'commentary.pendingAction.noAction': 'has the ball ',
  'commentary.kickoff': ' are taking kick off.',
  'commentary.roundresult.GOAL': ' scored a goal',
  'commentary.roundresult.SHOT_SAVED': ' saved a shot',
  'commentary.roundresult.PASS_SUCCESSFUL': ' received the ball',
  'commentary.roundresult.RUN_SUCCESSFUL': ' advances with the ball',
  'commentary.roundresult.DEFENSE_WIN': ' wins the ball',
  'commentary.roundresult.DRAW': ' retains possession',
  // from the defenders perspective
  'commentary.roundresult.ATTACK_STALL': ' took the ball',
  'commentary.roundresult.RUN_UNCONTESTED': ' ran with the ball uncontested',
  'commentary.roundresult.PASS_UNCONTESTED': ' received the ball in space',
  'commentary.roundresult.BOTH_STALL': ' dawdles on the ball',
  'commentary.playerRoundEvent.DISCARDED': ' was discarded',
  'commentary.playerRoundEvent.UNDEAD': ' was not discarded (undead)',
  'commentary.playerRoundEvent.STAMINA_LOSS': ` was not discarded (stamina)`,
  'commentary.playerRoundEvent.GOALIE_STAMINA_LOSS': ` was not discarded (goal keeper)`,
  'commentary.playerRoundEvent.SOUL_SAP_1': ' was discarded (soul sap)',
  'commentary.playerRoundEvent.SOUL_SAP_2': ' was discarded (soul sap)',
  'commentary.playerRoundEvent.RECOVERED':
    ' recovered and is no longer discarded',
  'commentary.playerRoundEvent.GOAL_MACHINE':
    ' was not discarded (goal machine)',
  'commentary.playerRoundEvent.IGNITE': ' got stronger (ignite)',
  'commentary.playerRoundEvent.INSPIRE': ' made teammates stronger (inspire)',
};
